import React from 'react'
import { useTranslate } from '../../../lib'
import { InputNesting } from '../../common/Inputs/Input'
import { SelectNesting } from '../../common/Inputs/Select'

export default function LLMSettings({
  showLLMSetting,
  setShowLLMSetting,
  model_llm_ref,
  temperature_ref,
  top_p_ref,
  top_k_ref,
  max_token_ref
}) {
  const { t } = useTranslate()

  return (
    <>
      {/* ENCABEZADO */}
      <div
        className='d-flex flex-row align-items-center justify-content-between w-100 mt-1 shadow_box'
        style={{
          backgroundColor: '#0088ff09',
          padding: 10,
          borderRadius: '10px 10px 0 0',
        }}
      >
        <div className='d-flex flex-row align-items-center w-100'>
          <div
            className='w-100'
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 onClick={() => setShowLLMSetting(!showLLMSetting)} style={{ color: '#0B5FA3', fontSize: 15, cursor: "pointer" }} className='m-0'>
              {t('menu.genai.selectLLM')}
            </h2>

            {!showLLMSetting && (
              <button type='button' className='ml-3' onClick={() => setShowLLMSetting(true)}>
                <img src='/icons/arrow_down.png' alt='' style={{ width: 15 }} />
              </button>
            )}

            {showLLMSetting && (
              <button type='button' className='ml-3' onClick={() => setShowLLMSetting(false)}>
                <img src='/icons/arrow_up.png' alt='' style={{ width: 15 }} />
              </button>
            )}
          </div>
        </div>
      </div>

      {/* CONTENIDO DESPLEGABLE */}
      <div
        style={{
          display: showLLMSetting ? 'flex' : 'none',
          backgroundColor: '#0088ff09',
          padding: '15px 10px 10px 10px',
        }}
        className='flex-column w-100 pt-3'
      >
        <div className='pb-2 d-flex flex-row flex-wrap align-items-center w-100'>
          <SelectNesting
            id="model_genAI"
            ref={model_llm_ref}
            containerClass="mr-3"
            boxInfo={true} tooltipText={t('menu.genai.selectLLMTooltip')}
            title={t('menu.genai.selectLLM')}
          >
            <option key='modelllm0' value='claude'>Claude</option>
            <option key='modelllm1' value='Open AI'>Open AI</option>
            <option key='modelllm2' value="tpgenai">TP Gen AI</option>
            <option key='modelllm3' value="Sonnetv2">Sonnet 3.5V2</option>
            <option key='modelllm4' value="scout">Llama Scout</option>
            <option key='modelllm5' value="maverick">Llama Maverick</option>
            <option key='modelllm6' value="Haiku">Haiku</option>
            <option key='modelllm7' value="opus4.1">Opus</option>
            <option key='modelllm8' value="Nova">Nova</option>
          </SelectNesting>

          <SelectNesting
            id="temperature"
            ref={temperature_ref}
            containerClass="mr-3" style={{ minWidth: 60 }}
            boxInfo={true} tooltipText={t('menu.genai.temperatureModelTooltip')}
            title={t('menu.genai.temperatureModel')}
          >
            <option key='temperature0' value='0'>0</option>
            <option key='temperature1' value='0.1'>0.1</option>
            <option key='temperature2' value="0.2">0.2</option>
            <option key='temperature3' value="0.3">0.3</option>
            <option key='temperature4' value="0.4">0.4</option>
            <option key='temperature5' value='0.5'>0.5</option>
            <option key='temperature6' value='0.6'>0.6</option>
            <option key='temperature7' value="0.7">0.7</option>
            <option key='temperature8' value="0.8">0.8</option>
            <option key='temperature9' value="0.9">0.9</option>
            <option key='temperature10' value="1">1</option>
          </SelectNesting>

          <SelectNesting
            id="top_p"
            ref={top_p_ref}
            containerClass="mr-3" style={{ minWidth: 60 }}
            boxInfo={true} tooltipText={t('menu.genai.topPTooltip')}
            title={`${t('menu.genai.topP')}:`}
          >
            <option key='topp0' value='0'>0</option>
            <option key='topp1' value='0.1'>0.1</option>
            <option key='topp2' value="0.2">0.2</option>
            <option key='topp3' value="0.3">0.3</option>
            <option key='topp4' value="0.4">0.4</option>
            <option key='topp5' value='0.5'>0.5</option>
            <option key='topp6' value='0.6'>0.6</option>
            <option key='topp7' value="0.7">0.7</option>
            <option key='topp8' value="0.8">0.8</option>
            <option key='topp9' value="0.9">0.9</option>
            <option key='topp10' value="1">1</option>
          </SelectNesting>

          <InputNesting
            ref={top_k_ref} id="top_k"
            type="number"
            containerClass="mr-3 d-flex flex-row align-center"
            title={`${t('menu.genai.topK')}:`}
            boxInfo={true}
            tooltip={true}
            tooltipText={t('menu.genai.topKTooltip')}
            style={{ maxWidth: 100 }}
          />

        </div>
      </div>
    </>
  )
}
